const spacingContactNumber = (contactNumber) => {
    if (!contactNumber || !contactNumber.length || contactNumber.length < 10) {
        return contactNumber;
    }
    return `${contactNumber.substring(0, 4)} ${contactNumber.substring(4, 7)} ${contactNumber.substring(7)}`;
};

export { spacingContactNumber };
